import { ShieldCheck, BadgeEuro, RefreshCcw } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

const TRUST_ITEMS = [
  {
    icon: ShieldCheck,
    title: "Pagamento sicuro",
    desc: "Transazione gestita tramite Stripe.",
  },
  {
    icon: BadgeEuro,
    title: "Prezzi trasparenti",
    desc: "Conosci il costo mensile prima dell'acquisto.",
  },
  {
    icon: RefreshCcw,
    title: "Abbonamento gestibile",
    desc: "Puoi gestire o interrompere i rinnovi secondo le condizioni dell'abbonamento.",
  },
];

export const StripeTrust = () => (
  <section id="pagamento-sicuro" className="bg-[#080808] py-24 sm:py-32">
    <div className="mx-auto max-w-5xl px-6 lg:px-8">
      <SectionHeading
        eyebrow="Pagamento sicuro tramite Stripe"
        title="Il tuo pagamento è protetto."
        subtitle="Per acquistare il tuo abbonamento utilizziamo Stripe Checkout, una piattaforma specializzata nella gestione dei pagamenti online. Il pagamento viene elaborato attraverso l'infrastruttura Stripe: non devi comunicare a Elio, Chiara o ai coach i dati della tua carta."
        testid="stripe-trust-heading"
      />
      <div className="grid gap-5 sm:grid-cols-3">
        {TRUST_ITEMS.map((item, i) => (
          <Reveal key={item.title} delay={0.08 * i}>
            <div
              data-testid={`trust-item-${i + 1}`}
              className="h-full rounded-sm border border-[#1B1B1B] bg-[#121212] p-8 text-center"
            >
              <item.icon
                className="mx-auto h-8 w-8 text-[#C9A45C]"
                aria-hidden="true"
                strokeWidth={1.5}
              />
              <h3 className="mt-4 text-sm font-bold uppercase tracking-widest text-white">
                {item.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-[#B8B8B8]">
                {item.desc}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
